// Tracked share-URL builder for public files.
//
// A "tracked" file link points at the backend redirect endpoint
// (`/api/f/<fileId>`) instead of the raw S3 object. The backend logs a
// direct-hit `fileAccess` block (geo, referrer, campaign params) and then
// 302-redirects to the real file. Campaign links MUST use this tracked base
// so hits are attributed; the raw public URL bypasses tracking.
//
// The Campaigns feature consumes `buildTrackedFileUrl` — keep the signature
// stable: (fileId, params) => string.

// REST origin = the configured GraphQL/backend URL without the trailing
// `/graphql` segment. Mirrors src/graphQL/user/index.js.
const GRAPHQL_URL =
  process.env.REACT_APP_GRAPHQL_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "https://backend.prod.oelement.net/graphql";

export const BACKEND_ORIGIN = GRAPHQL_URL.replace(/\/graphql\/?$/, "");

// The campaign/UTM param keys we forward, in a stable order.
export const CAMPAIGN_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
  "adId",
  "cs_campaign",
];

// Build a query string from an object, dropping empty / null / undefined
// values and preserving insertion order. Pure — no side effects.
export const buildQueryString = (params = {}) => {
  const usp = new URLSearchParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value === undefined || value === null) return;
    const str = String(value).trim();
    if (!str) return;
    usp.append(key, str);
  });
  return usp.toString();
};

// Build the tracked redirect URL for a file.
//   buildTrackedFileUrl("abc", { utm_source: "email" })
//     => "https://backend.../api/f/abc?utm_source=email"
// Returns "" when no fileId is supplied.
export const buildTrackedFileUrl = (fileId, params = {}, origin = BACKEND_ORIGIN) => {
  if (!fileId) return "";
  const base = `${origin}/api/f/${encodeURIComponent(fileId)}`;
  const qs = buildQueryString(params);
  return qs ? `${base}?${qs}` : base;
};

export default buildTrackedFileUrl;
